export default {
	appointment_save_failed_notification: 'Appointment could not be saved',
	appointment_saved_notification: 'Appointment saved',
	calendar_agenda_button_today_label: 'Today',
	calendar_agenda_next_day_aria_label: 'Next day',
	calendar_agenda_previous_day_aria_label: 'Previous day',
	calendar_agenda_time_independent_appointments_timeline_entry_label: 'Time-independent appointments',
	calendar_agenda_week_view_aria_label: 'Go to week view',
	calendar_appointment_access_label: 'Access',
	calendar_appointment_access_label_private: 'Private',
	calendar_appointment_access_label_public: 'Public',
	calendar_appointment_alarm_before_days_label: 'day(s)',
	calendar_appointment_alarm_before_deactivated_label: 'No alarm',
	calendar_appointment_alarm_before_hours_label: 'hour(s)',
	calendar_appointment_alarm_before_minutes_label: 'minute(s)',
	calendar_appointment_alarm_before_select_option_days_label: 'day(s)',
	calendar_appointment_alarm_before_select_option_deactivated_label: 'No alarm',
	calendar_appointment_alarm_before_select_option_hours_label: 'hour(s)',
	calendar_appointment_alarm_before_select_option_minutes_label: 'minute(s)',
	calendar_appointment_alarm_label: 'Alert before appointment',
	calendar_appointment_day: 'Day',
	calendar_appointment_delete_dialog_confirm_cancel_label: 'No',
	calendar_appointment_delete_dialog_confirm_message: 'Do you really want to delete this appointment?',
	calendar_appointment_delete_dialog_confirm_ok_label: 'Yes',
	calendar_appointment_delete_dialog_confirm_title: 'Delete appointment',
	calendar_appointment_description_label: 'Description',
	calendar_appointment_duration_hours: 'Hours',
	calendar_appointment_duration_hours_short: 'h',
	calendar_appointment_duration_label: 'Duration',
	calendar_appointment_duration_minutes: 'Minutes',
	calendar_appointment_duration_minutes_short: 'min',
	calendar_appointment_edit_repetition_notification:
		'Info - you are editing a repetition appointment. Only the current appointment is edited and not all appointments of the repetition.',
	calendar_appointment_edit_repetition_ok_button_label: 'Ok, got it',
	calendar_appointment_list: 'List',
	calendar_appointment_location_label: 'Location',
	calendar_appointment_month: 'Month',
	calendar_appointment_participant_accept_label: 'Confirmation',
	calendar_appointment_participant_active_label: 'Active participant',
	calendar_appointment_participant_active_name: 'Name',
	calendar_appointment_participant_alert_label: 'Alert',
	calendar_appointment_participant_remove_aria_label: 'Remove participant',
	calendar_appointment_participant_write_label: 'Write right',
	calendar_appointment_participants_label: 'Participants',
	calendar_appointment_repetition_delete_scope_all: 'including all subsequent repeat appointments',
	calendar_appointment_repetition_delete_scope_message: 'Which appointments should be deleted?',
	calendar_appointment_repetition_delete_scope_single: 'Only this appointment',
	calendar_appointment_repetition_delete_scope_title: 'Delete appointment',
	calendar_appointment_repetition_ending_amount: 'After count',
	calendar_appointment_repetition_ending_amount_label: 'Count',
	calendar_appointment_repetition_ending_date: 'On date',
	calendar_appointment_repetition_ending_date_label: 'End date',
	calendar_appointment_repetition_ending_label: 'Ending',
	calendar_appointment_repetition_ending_never: 'Never (until 2038)',
	calendar_appointment_repetition_interval_label: 'Interval',
	calendar_appointment_repetition_label: 'Repetition',
	calendar_appointment_repetition_month_by_date: 'Same date',
	calendar_appointment_repetition_month_by_day: 'Same weekday',
	calendar_appointment_repetition_off: 'inactive',
	calendar_appointment_repetition_on: 'active',
	calendar_appointment_repetition_save_scope_all: 'including all subsequent repeat appointments',
	calendar_appointment_repetition_save_scope_message: 'How should the appointment be saved?',
	calendar_appointment_repetition_save_scope_single: 'Only this appointment',
	calendar_appointment_repetition_save_scope_title: 'Save appointment',
	calendar_appointment_repetition_type_day: 'Daily',
	calendar_appointment_repetition_type_label: 'Repetition type',
	calendar_appointment_repetition_type_month: 'Monthly',
	calendar_appointment_repetition_type_week: 'Weekly',
	calendar_appointment_repetition_type_year: 'Yearly',
	calendar_appointment_repetition_weekday_fri: 'Fri',
	calendar_appointment_repetition_weekday_mon: 'Mon',
	calendar_appointment_repetition_weekday_sat: 'Sat',
	calendar_appointment_repetition_weekday_sun: 'Sun',
	calendar_appointment_repetition_weekday_thu: 'Thu',
	calendar_appointment_repetition_weekday_tue: 'Tue',
	calendar_appointment_repetition_weekday_wed: 'Wed',
	calendar_appointment_start_label: 'Start',
	calendar_appointment_start_minutes: 'Minutes',
	calendar_appointment_start_oclock: "o'clock",
	calendar_appointment_time_type_allday: 'all day',
	calendar_appointment_time_type_fixed: 'fixed time',
	calendar_appointment_time_type_label: 'Mode',
	calendar_appointment_time_type_time_independent: 'time-independent',
	calendar_appointment_type_label: 'Appointment type',
	calendar_appointment_user_selection: 'User selection',
	calendar_appointment_week: 'Week',
	calendar_appointment_year: 'Year',
	calendar_appointment_years: 'Years',
	calendar_datefield_close: 'Close',
};
